import axios from 'axios';

export function submitFeedback(params) {
  return axios.post('/apigw/v1/insights/feedback', params);
}
